import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { TabsContent } from '@/components/ui/tabs';
import { Mail, Lock, ArrowRight } from 'lucide-react';

export default function LoginForm({
  loginEmail, setLoginEmail, loginPassword, setLoginPassword,
  rememberEmail, setRememberEmail, onClearSavedEmail, loading, onSubmit,
}) {
  const navigate = useNavigate();

  return (
    <TabsContent value="login">
      <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form">
        <div>
          <Label htmlFor="login-email" className="uppercase text-xs font-bold text-muted-foreground mb-1.5 block">
            Email
          </Label>
          <div className="relative">
            <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
            <Input
              id="login-email"
              data-testid="login-email-input"
              type="email"
              autoComplete="email"
              placeholder="your@email.com"
              value={loginEmail}
              onChange={(e) => setLoginEmail(e.target.value)}
              className="h-14 rounded-2xl bg-secondary border-transparent focus:border-primary pl-12"
              required
            />
          </div>
          {/* Remember / clear controls */}
          <div className="flex items-center justify-between mt-2.5 px-1">
            <label className="flex items-center gap-2 cursor-pointer select-none">
              <input
                type="checkbox"
                data-testid="remember-email-checkbox"
                checked={rememberEmail}
                onChange={(e) => setRememberEmail(e.target.checked)}
                className="w-4 h-4 accent-[#7BCB00] cursor-pointer"
              />
              <span className="text-xs text-muted-foreground">Remember my email on this device</span>
            </label>
            <button
              type="button"
              onClick={onClearSavedEmail}
              data-testid="clear-saved-email-link"
              className="text-xs text-muted-foreground hover:text-emerald-600 underline-offset-2 hover:underline"
            >
              Not your device?
            </button>
          </div>
        </div>
        <div>
          <Label htmlFor="login-password" className="uppercase text-xs font-bold text-muted-foreground mb-1.5 block">
            Password
          </Label>
          <div className="relative">
            <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
            <Input
              id="login-password"
              data-testid="login-password-input"
              type="password"
              placeholder="••••••••"
              value={loginPassword}
              onChange={(e) => setLoginPassword(e.target.value)}
              className="h-14 rounded-2xl bg-secondary border-transparent focus:border-primary pl-12"
              required
            />
          </div>
        </div>
        <div className="text-right">
          <button
            type="button"
            onClick={() => navigate('/forgot-password')}
            className="text-sm text-emerald-600 hover:text-emerald-700 font-semibold"
          >
            Forgot Password?
          </button>
        </div>
        <Button
          type="submit"
          data-testid="login-submit-button"
          className="w-full btn-volt h-14"
          disabled={loading}
        >
          {loading ? 'Logging in...' : 'Login'}
          <ArrowRight className="ml-2 w-5 h-5" />
        </Button>
      </form>
    </TabsContent>
  );
}
